import { createFileRoute } from '@tanstack/react-router'
import { DoctorsProfile } from '@/features/doctors/doctor-profile'
import { useAuth } from '@/context/auth-context'

export const Route = createFileRoute('/_authenticated/doctors/me')({
  component: RouteComponent,
})

function RouteComponent() {
  const { state } = useAuth()
  const doctorId = state.user?.id

  if (!doctorId) return null

  return <DoctorsProfile doctorId={doctorId} activeTab="overview" />
}
